import { useEffect, useState } from 'react';

/**
 * The typed value, settled.
 *
 * Search-as-you-type against 25,000 products means a query per keystroke unless
 * something holds the value still first. 300ms is the figure the catalogue has
 * used since it was built: long enough that an ordinary typing speed produces
 * one request per word rather than per letter, short enough that the list feels
 * like it is following you.
 *
 * Extracted so the three search boxes cannot drift apart — a catalogue that
 * waits 300ms beside a purchases list that waits 800 reads as one of them being
 * broken.
 */
export function useDebounced(value: string, delayMs = 300): string {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value.trim()), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
